import { pushEvent } from '../googleTagManager/googleTagManagerUtils';

import type { TAuthenticationEvent } from './types';

//functions

/**
 * Push a registration success event to GTM.
 * Called when user successfully completes the registration process.
 */
export const pushRegisterSuccessEvent = (): void => {
	pushEvent({ event: 'registerSuccess' });
};

/**
 * Push a personal details completion event to GTM.
 * Called when user completes their profile information during registration.
 */
export const pushPersonalDetailsCompletedEvent = (): void => {
	pushEvent({ event: 'personal_details_completed' });
};

/**
 * Push an authentication-related event to GTM.
 * Handles login and sign-up flows with their attempt/success states.
 */
export const pushAuthEvent = (
	event: TAuthenticationEvent['event'],
	method: TAuthenticationEvent['method']
): void => {
	pushEvent({ event, method });
};
